import { signUserFunction } from './gallery-properties.flow'

export default signUserFunction(calcHighlightSeveralPosts)

function calcHighlightSeveralPosts(_rawVal, calcProp) {
  const highlight_period = calcProp('highlight_period')
  return highlight_period > 1
}
